import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./reducers/layout/authSlice";
import LayoutSlice from "./reducers/layout/layoutSlice";
import ThemeCustomizerSlice from "./reducers/layout/themeCustomizerSlice";
import roleSlice from "./reducers/roles/roleSlice";
import userSlice from './reducers/users/userSlice';
import  updateProfileSlice from './reducers/layout/UpdateProfileSlice';
import { profile } from "console";
import { PersistConfig, persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";

const persistConfig = {

  key:'root',
  storage,
  whitelist: ['role', 'user', 'profile'], 
}

const rootReducer = combineReducers({
  auth: authSlice,
  layout: LayoutSlice,
  themeCustomizer: ThemeCustomizerSlice,
  role: roleSlice,
  user : userSlice,
  profile:updateProfileSlice,
});

const persistedReducer = persistReducer(persistConfig,rootReducer);

export const store = configureStore({
    reducer:persistedReducer,
})
     
export const persistor = persistStore(store);


/*export const store = configureStore({
  reducer: {
    auth: authSlice,
    layout: LayoutSlice,
    themeCustomizer: ThemeCustomizerSlice,
    role: roleSlice,
    user : userSlice,
    profile:updateProfileSlice,
  },
});*/

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
